import React, { useState } from 'react';

import { Button, Icons, Modal } from '@components/common';

import { IMoveFolderDTO } from '@interfaces/portal/dto/foldersManagementDTO';
import { IDestinationFolderForMove, IFolderForMove } from '../MoveFolderForm/interfaces';

import { selectFolderModalTitle } from './constants';

import SelectFolderForMoveModal from './SelectFolderForMoveModal';

import styles from './MoveFolderForm.module.scss';

interface IMoveFolderFormProps {
	folderForMove: IFolderForMove | null;
	closeMoveFolderForm: () => void;
	handleMoveFolder: (data: IMoveFolderDTO) => void;
}

const MoveFolderForm = ({
	folderForMove,
	closeMoveFolderForm,
	handleMoveFolder,
}: IMoveFolderFormProps) => {
	const [isSelectFolderModal, setIsSelectFolderModal] = useState(false);
	const [destinationFolder, setDestinationFolder] = useState<IDestinationFolderForMove | null>(null);

	const openSelectFolderModal = () => setIsSelectFolderModal(true);

	const closeSelectFolderModal = () => setIsSelectFolderModal(false);

	const onSelectFolder = (selectedFolder: IDestinationFolderForMove | null) => {
		setDestinationFolder(selectedFolder);
		closeSelectFolderModal();
	};

	const handleProceed = () => {
		if (!folderForMove?.folderId || !destinationFolder?.folderId) {
			return;
		}

		handleMoveFolder({
			folderId: folderForMove.folderId,
			destinationFolderId: destinationFolder.folderId,
			isParentFolder: folderForMove.isParentFolder,
		});

		closeMoveFolderForm();
	};

	const isProceedDisabled = !(folderForMove?.folderId && destinationFolder?.folderId);

	return (
		<>
			<div className={styles.folderInputsContainer}>
				<div className={styles.folderInput}>
					<div className={styles.label}>
						Current Folder
					</div>
					<div className={styles.folderNameContainer}>
						<div className={styles.icon}>
							{folderForMove?.folderHasContent ? Icons.folderIcon() : Icons.folderEmpty()}
						</div>
						<div className={styles.folderName}>{
							folderForMove?.folderName || ''}
						</div>
					</div>
				</div>
				<div className={styles.folderInput}>
					<div className={styles.label}>
						Destination Folder
					</div>
					{destinationFolder
						&& <div className={styles.folderNameContainer}>
							<div className={styles.icon}>
								{destinationFolder?.folderHasContent ? Icons.folderIcon() : Icons.folderEmpty()}
							</div>
							<div className={styles.folderName}>
								{destinationFolder?.folderName || ''}
							</div>
						</div>
					}
					<div
						className={styles.selectFolderButton}
						onClick={openSelectFolderModal}
					>
						{selectFolderModalTitle}
					</div>
				</div>
			</div>
			<div className={styles.buttons}>
				<Button
					onClick={closeMoveFolderForm}
					text='Cancel'
					withoutBackground
				/>
				<Button
					disabled={isProceedDisabled}
					onClick={handleProceed}
					text='Proceed'
				/>
			</div>
			<Modal
				isOpen={isSelectFolderModal}
				isScrollableContent
				onClose={closeSelectFolderModal}
				title={selectFolderModalTitle}
				width='400px'
			>
				<SelectFolderForMoveModal
					folderId={folderForMove?.folderId}
					onSelect={onSelectFolder}
				/>
			</Modal>
		</>
	);
};

export default MoveFolderForm;
